import { render, staticRenderFns } from "./markCategories.vue?vue&type=template&id=ca950d16&scoped=true&"
import script from "./markCategories.vue?vue&type=script&lang=js&"
export * from "./markCategories.vue?vue&type=script&lang=js&"
import style0 from "./markCategories.vue?vue&type=style&index=0&id=ca950d16&lang=scss&scoped=true&"
import style1 from "./markCategories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca950d16",
  null
  
)

export default component.exports